import ViewCompactIcon from '@material-ui/icons/ViewCompact';
import gridList from './gridList';

const resource = {
    list: gridList,
    icon: ViewCompactIcon,
};

export default resource;